"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var localStorage_1 = __importDefault(require("../../../config/localStorage"));
var country_hook_1 = require("../../../context/CountryContext/country.hook");
var disContext_1 = require("../../../context/DiseaseContext/disContext");
var org_hook_1 = require("../../../context/OrgContext/org.hook");
var general_1 = require("../../../lib/general");
require("./Disease.css");
var Queries_1 = require("./Graphql/Queries");
var DiseaseCard = function () {
    var _a;
    var history = (0, react_router_dom_1.useHistory)();
    var setCurrentDisease = (0, react_1.useContext)(disContext_1.DisContext).setCurrentDisease;
    var country = (0, country_hook_1.useCountry)().country;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _b = (0, react_i18next_1.useTranslation)(), i18n = _b.i18n, t = _b.t;
    var data = (0, client_1.useQuery)(Queries_1.GET_DISEASES, {
        variables: {
            organization_id: organization.id,
        },
    }).data;
    var handleClick = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localStorage_1.default.setItem("disease", val)];
                case 1:
                    _a.sent();
                    setCurrentDisease(val);
                    history.push("/admin/disease");
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "card" }, (_a = data === null || data === void 0 ? void 0 : data.getDiseasesList) === null || _a === void 0 ? void 0 : _a.map(function (val) { return (react_1.default.createElement("button", { className: "cardButton", key: val.id, onClick: function () {
            handleClick(val);
        } },
        react_1.default.createElement("div", { className: "productCard" },
            react_1.default.createElement("img", { className: "imageDisease", src: "".concat((0, general_1.generateMediaLink)(val.image_app, organization === null || organization === void 0 ? void 0 : organization.id, 
                // user?.detail?.address_country,
                country)) }),
            react_1.default.createElement("h3", null, (0, general_1.isJsonWithAvailableLang)(val.name, i18n.language, t))))); })));
};
exports.default = DiseaseCard;
